<template>
  <div class="mcq-container">
    <div class="row">
      <div class="small-12 columns">
        <div class="small-6 columns">
          <button
            class="px-8 border bg-green border-green py-2 text-white absolute ml-4"
            @click="createNewMCQ"
          >
            Add MCQ
          </button>
        </div>
      </div>
      <div class="w-1/2 m-auto text-center">
        <div>
          <div class="my-1">Search by content</div>
          <div class="">
            <input
              v-model="searchByContent"
              type="text"
              style="width:90%;margin:auto;"
              @input="filterByContent"
            />
          </div>
        </div>
      </div>
      <div class="w-1/2 m-auto">
        <div class="" style="">
          <div class="text-center my-2">Search by Tags</div>
          <div class="w-full block m-auto">
            <VueSelect
              v-model="selectedTags"
              :options="tagOptions"
              label="name"
              multiple
              @input="populateQuestions"
            />
          </div>
        </div>
      </div>
      <div class="my-2 mx-auto text-center w-1/2">
        <p class="mb-2">Select per page result</p>
        <select
          v-model="per_page"
          class="m-auto w-1/4 bg-white p-1 border"
          selected="20"
          @change="handlePerPageResultCountChange"
        >
          <option disabled="true">Max results per page</option>
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
          <option value="40">40</option>
          <option value="50">50</option>
          <option value="70">70</option>
          <option value="100">100</option>
        </select>
      </div>
      <small class="text-red text-center block m-auto"
        >* Per page count and displayed questions count may vary, stitched MCQs
        aren't displayed here
      </small>
    </div>
    <div>
      <h3 class="text-center mb-4 border-b pb-3">
        Page {{ page }} of {{ totalPages }}
      </h3>

      <div class="page-numbers overflow-auto flex flex-row mb-4">
        <div v-for="num in totalPages" :key="num + '-question-page'">
          <div
            class="p-1 border rounded-full flex-shrink-1 m-1 mb-4 page-number"
            :class="page === num ? 'bg-grey-darker text-white' : 'bg-white'"
            @click="setPage"
          >
            {{ num }}
          </div>
        </div>
      </div>
    </div>
    <SweetModal
      ref="mcqadd"
      width="80%"
      @open="modalOpen = true"
      @close="modalOpen = false"
    >
      <MCQEditor
        v-if="modalOpen"
        :mcq-object="mcqObject"
        :editing="editingMCQ"
        @MCQ_OBJECT_CREATE_EMIT="createEmittedQuestion"
        @MCQ_OBJECT_EDIT_EMIT="editEmittedQuestion"
      />
    </SweetModal>
    <TableComponent
      :table-data="response"
      @editClicked="editMCQItem"
      @deleteClicked="deleteMCQItem"
    />
  </div>
</template>

<script>
import VueSelect from "vue-select"
import { mapActions } from "vuex"
import { SweetModal } from "sweet-modal-vue"
import siteConfig from "@/utils/siteConfig"
import MCQEditor from "@/components/questions/mcqHelpers/MCQEditor"

import TableComponent from "@/components/questions/mcqHelpers/TableComponent"

export default {
  components: { SweetModal, MCQEditor, TableComponent, VueSelect },
  data() {
    return {
      page: 1,
      per_page: 20,
      totalPages: "",
      url: "",
      currentQuestion: undefined,
      response: undefined,
      mcqObject: {},
      modalOpen: false,
      editingMCQ: false,
      // / Prev next button state props
      MCQViewingMinimumIndex: undefined,
      MCQCurrentViewingIndex: undefined,
      MCQMaxViewingIndex: undefined,
      // /////
      searchByContent: "",
      tagOptions: [],
      selectedTags: [],
    }
  },
  watch: {
    $route() {
      this.populateQuestions()
    },
  },
  created() {
    this.page = parseInt(this.$route.query.page) || 1
    this.per_page = this.$route.query.per_page || 20
    this.$nextTick(() => {
      window.Prism.highlightAll()
    })
    // minimum index for MCQ views,
    this.MCQViewingMinimumIndex = 0
    // current index for MCQ view
    this.MCQCurrentViewingIndex = 0
    this.populateQuestions()
    this.populateTags()
  },
  methods: {
    ...mapActions("module", ["SET_CURRENT_TAG_LIST"]),
    setPage(e) {
      const pageNo = parseInt(e.target.textContent)
      this.page = pageNo
      this.gotoPage()
    },
    gotoPage() {
      this.$router.push({
        name: "MCQ",
        query: { page: this.page, per_page: this.per_page },
      })
    },
    handlePerPageResultCountChange() {
      this.page = 1
      this.gotoPage()
    },
    filterByContent() {
      const string = this.searchByContent

      this.response = this.response.filter(item =>
        item.content.includes(string)
      )
      if (string.length === 0) {
        this.populateQuestions()
      }
    },
    populateTags() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}qtags/?pagination=false`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.tagOptions = res.data.items.map(item => ({
          id: item.id,
          name: item.name,
        }))
      })
    },
    editMCQItem(obj) {
      for (let i = 0; i < this.response.length; i++) {
        if (this.response[i].id === obj.id) {
          this.MCQCurrentViewingIndex = i
        }
      }
      this.mcqObject = obj
      this.editingMCQ = true
      this.$refs.mcqadd.open()
    },
    deleteMCQItem(obj) {
      const { id } = obj

      this.axios({
        method: "delete",
        url: `${siteConfig.siteURL}questions/${id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(() => {
        this.populateQuestions()
      })
    },
    createNewMCQ() {
      this.editingMCQ = false
      this.mcqObject = {
        list: {
          options: [],
        },
        name: "Edit Question",
        answers: [],
        explain: "",
        attachments: [],
      }
      this.SET_CURRENT_TAG_LIST([])
      this.$refs.mcqadd.open()
    },
    editEmittedQuestion(a) {
      const question = a
      if (question.answers.length === 0) {
        alert("Please select an answer!")
        return
      }
      const payload = {
        answers: question.answers,
        content: question.content,
        tries: 0,
        points: question.points,
        name: "",
        is_required: true,
        list: question.list,
        type: 1,
        item_cursor: 0,
        is_dependent_ids: "[]",
        attachments: question.attachments,
        explain: question.explain,
        ops_qtags: question.ops_qtags,
        ops_qtags_unlink: question.ops_qtags_unlink,
      }
      this.axios({
        method: "put",
        url: `${siteConfig.siteURL}questions/${question.id}`,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(() => {
        this.$refs.mcqadd.close()
        this.populateQuestions()
      })
    },
    createEmittedQuestion(a) {
      const question = a
      if (question.answers.length === 0) {
        alert("Please select an answer!")
        return
      }
      const payload = {
        answers: question.answers,
        content: question.content,
        tries: 0,
        points: question.points,
        name: "",
        is_required: true,
        list: question.list,
        type: 1,
        item_cursor: 0,
        is_dependent_ids: "[]",
        attachments: question.attachments,
        explain: question.explain,
        ops_qtags: question.ops_qtags,
      }

      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}questions/`,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(() => {
        this.$refs.mcqadd.close()
        this.populateQuestions()
      })
    },
    populateQuestions() {
      this.url = `${siteConfig.siteURL}admin/questions?search_by_type=1&fields=id,type,name,answers,list,points,qtags,content,explain&page=${this.page}&per_page=${this.per_page}`

      if (this.selectedTags) {
        this.selectedTags.forEach(tag => {
          this.url = `${this.url}&search_by_qtagid=${tag.id}`
        })
      }

      this.axios({
        method: "get",
        url: this.url,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.totalPages = res.data.pages

        this.response = res.data.items.filter(item => {
          item.answers = JSON.parse(item.answers)
          item.list = JSON.parse(item.list)
          return item.list.has === undefined
        })
        this.MCQMaxViewingIndex = this.response.length
        this.MCQCurrentViewingIndex = 0
      })
    },
  },
}
</script>
<style scoped>
.page-number {
  width: 30px;
  height: 30px;
  text-align: center;
  cursor: pointer;
}
</style>

<style>
.mcq-data-row-options {
  display: none;
  position: absolute;
  z-index: 10;
  top: -10px;
  left: 50%;
  padding: 2px 10px;
  border: 1px solid grey;
  background-color: white;
}
.mcq-data-row:hover > .mcq-data-row-options {
  display: block;
}
.mcq-data-row:hover {
  background-color: #c2f983;
}
.mcq-data-row {
  position: relative;
  padding: 2px;
  border: 1px solid black;
}

.mcq-container {
  margin-top: 40px;
}

.CodeMirror-scroll {
  min-height: 80px !important;
}
.CodeMirror {
  min-height: 80px !important;
}
</style>
